import { createSlice } from "@reduxjs/toolkit";

const calendarSlice = createSlice({
  name: "calendarDate",
  initialState: {
    selectedDate: null,
    militaryTime: false
  },
  reducers: {
    setDateRange: (state, action) => {
      state.selectedDate = action.payload.selectedDate;
    },
    setMilitaryTime: (state, action) => {
      state.militaryTime = action.payload.militaryTime;
    },
  },
});

export const { setDateRange, setMilitaryTime } = calendarSlice.actions;
export default calendarSlice.reducer;
